import { render, staticRenderFns } from "./InvoiceAiForm.vue?vue&type=template&id=2da361b0&scoped=true"
import script from "./InvoiceAiForm.vue?vue&type=script&lang=js"
export * from "./InvoiceAiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da361b0",
  null
  
)

export default component.exports